/* ==========================================================================
   New Home Barn Megamenu - MOBILE - See admin notes for more details.
   Drives hb-megamenu-mobile.liquid inside the theme's existing #NavDrawer.
   Does not touch theme.Drawers or theme.collapsibles - only shows/hides
   pre-rendered screens and swaps the drawer's own title element for a
   breadcrumb, exactly the way the approved prototype's mobile drill-down
   behaves (state machine ported from _renderMobile()).

   This content is now Level 1 the moment the drawer opens (no separate
   "Shop" trigger) - the normal New In/Shop/Inspiration/Contact list is
   permanently hidden via CSS, not swapped in/out at runtime, so this file
   only needs to manage navigation between Levels A/B/C.
   ========================================================================== */
(function () {
  function init() {
    var drawer = document.getElementById('NavDrawer');
    var mobile = document.querySelector('[data-hb-mobile]');
    if (!drawer || !mobile) return;

    var titleEl = drawer.querySelector('.drawer__title');
    var backRow = mobile.querySelector('[data-hb-mobile-back]');
    var backBtn = mobile.querySelector('[data-hb-mobile-back-btn]');

    // history of screens visited, so "back" can unwind one step at a time -
    // e.g. ['a'] -> ['a','b:furniture'] -> ['a','b:furniture','c:cabinets-cupboards']
    var stack = ['a'];

    function showScreen(selector, title) {
      mobile.querySelectorAll('[data-hb-mobile-screen]').forEach(function (s) {
        s.classList.remove('is-active');
      });
      var target = mobile.querySelector(selector);
      if (target) target.classList.add('is-active');
      if (titleEl) titleEl.innerHTML = title || '';
      backRow.hidden = stack.length <= 1;
    }

    function resetToLevelA() {
      stack = ['a'];
      showScreen('[data-hb-mobile-screen="a"]', '');
    }

    function goto(level, target) {
      if (level === 'b') {
        stack.push('b:' + target);
        var panel = mobile.querySelector('[data-hb-mobile-screen="b"][data-hb-mobile-section="' + target + '"]');
        showScreen('[data-hb-mobile-screen="b"][data-hb-mobile-section="' + target + '"]', panel ? panel.dataset.hbMobileTitle : '');
      } else if (level === 'c') {
        stack.push('c:' + target);
        var panelC = mobile.querySelector('[data-hb-mobile-screen="c"][data-hb-mobile-item="' + target + '"]');
        showScreen('[data-hb-mobile-screen="c"][data-hb-mobile-item="' + target + '"]', panelC ? panelC.dataset.hbMobileTitle : '');
      }
    }

    function back() {
      if (stack.length <= 1) return; // already at Level A - no back button shown anyway
      stack.pop();
      var current = stack[stack.length - 1];
      if (current === 'a') {
        showScreen('[data-hb-mobile-screen="a"]', '');
      } else {
        var parts = current.split(':');
        var level = parts[0], target = parts[1];
        if (level === 'b') {
          var panel = mobile.querySelector('[data-hb-mobile-screen="b"][data-hb-mobile-section="' + target + '"]');
          showScreen('[data-hb-mobile-screen="b"][data-hb-mobile-section="' + target + '"]', panel ? panel.dataset.hbMobileTitle : '');
        }
      }
    }

    backBtn.addEventListener('click', back);

    mobile.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hb-mobile-goto]');
      if (!btn) return;
      goto(btn.dataset.hbMobileGoto, btn.dataset.hbMobileTarget);
    });

    // Reset to Level A whenever the drawer itself closes, by whatever path
    // (close button, backdrop click, etc.) - watching the class attribute
    // catches all of them without hooking every trigger individually.
    var observer = new MutationObserver(function () {
      if (!drawer.classList.contains('drawer--is-open') && stack.length > 1) {
        resetToLevelA();
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
